export class WayToPayModel {
  wayToPayId: number = 0;
  companyId: number = 0;
  code: number = 0;
  description: string = '';
  account: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}